import React from 'react';
import StreamPlayerContext, { StreamPlayerContextValues } from '../_contexts/stream-player-context';

export const useVodPlayer = (): StreamPlayerContextValues => {
  const values = React.useContext(StreamPlayerContext);

  return { ...values };
};

export default useVodPlayer;
